<template>
  <div class="row content-box full-height">
    <woot-wizard class="hide-for-small-only medium-3 columns" :items="items" />
    <router-view />
  </div>
</template>

<script>
import { resetDraft } from './draftState';

export default {
  computed: {
    isNewDraftFlow() {
      return this.$route.name.startsWith('settings_opportunity_pipelines_new');
    },
    items() {
      const items = this.$t('OPPORTUNITY_PIPELINES.CREATE_FLOW.WIZARD');

      if (this.isNewDraftFlow) {
        const routeMap = [
          'settings_opportunity_pipelines_new',
          'settings_opportunity_pipelines_new_users',
          'settings_opportunity_pipelines_new_inboxes',
          'settings_opportunity_pipelines_new_stages',
          'settings_opportunity_pipelines_new_loss_reasons',
          'settings_opportunity_pipelines_new_finish',
        ];

        return items.map((item, index) => ({
          ...item,
          route: routeMap[index],
        }));
      }

      if (this.$route.name !== 'settings_opportunity_pipelines_edit') {
        return items;
      }

      return items.map((item, index) => {
        if (index !== 0) {
          return item;
        }

        return {
          ...item,
          route: 'settings_opportunity_pipelines_edit',
        };
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (
      to?.name === 'settings_opportunity_pipelines_new' &&
      !(from?.name || '').startsWith('settings_opportunity_pipelines_new')
    ) {
      resetDraft();
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (this.shouldResetDraft(to, from)) {
      resetDraft();
    }
    next();
  },
  methods: {
    shouldResetDraft(to, from) {
      const isCreateEntry = to?.name === 'settings_opportunity_pipelines_new';
      const cameFromCreateFlow = (from?.name || '').startsWith(
        'settings_opportunity_pipelines_new'
      );

      return isCreateEntry && !cameFromCreateFlow;
    },
  },
};
</script>
